module.exports = __webpack_public_path__ + "img/Sirichon-v1.78e89e68.png";